import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './../spzaComponent';
import { logClientError } from '../../utils/appUtils';
export class ErrorModal extends SpzaComponent {
    renderFailImpl(err) {
        // We don't want error modal while trying to render error modal since it goes into a loop.
        // So, we are seperately handling the error case.
        logClientError(err, 'client side error: [From errorModal] ');
        return null;
    }
    // Error modal is rendered from the main client hookup
    // It may not have context hence the localization is handled here via localizedStrings props
    translate(key, fallback) {
        let context = this.context;
        if (context && context.loc) {
            return context.loc(key, fallback);
        } else if (this.props.localizedStrings) {
            let translated = this.props.localizedStrings[key];
            translated = translated ? translated : fallback ? fallback : key;
            return translated;
        }
    }
    renderImpl() {
        return /*#__PURE__*/ _jsx("div", {
            role: "dialog",
            "aria-label": "error is now open. something went wrong",
            className: "errorModalClass",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "prompContainer",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "toolBar",
                        children: /*#__PURE__*/ _jsx("button", {
                            id: "cancelButton",
                            "aria-label": "close",
                            className: "cancel",
                            onClick: this.props.dismissModal,
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "c-glyph"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "errorModal",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "contentHeader",
                                children: this.props.isEmbed ? this.translate('ERROR_Title_Embed', 'Sorry, an error occurred.') : this.translate('ERROR_Title', 'Something went wrong')
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "errorContent",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "errorMessage",
                                        children: this.props.isEmbed ? this.translate('ERROR_Subtitle_Embed', 'Please try again.') : this.translate('ERROR_Subtitle', 'Go to the homepage to try that again.')
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "dismissErrorButton",
                                        children: /*#__PURE__*/ _jsx("button", {
                                            name: "button",
                                            className: "c-button",
                                            type: "submit",
                                            onClick: this.props.dismissModal,
                                            children: this.props.isEmbed ? this.translate('Dialog_Close', 'Close') : this.translate('ERROR_Link', 'Home')
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
    constructor(props, context){
        super(props, context);
    }
}
ErrorModal.contextTypes = {
    loc: PropTypes.func
};
